import { Component } from '@angular/core';
import { BaseIconComponent } from './base-icon.component';

@Component({
  selector: 'lib-download-file-icon',
  standalone: true,
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      [attr.width]="width()"
      [attr.height]="height()"
      [attr.viewBox]="viewBox()"
      fill="none"
      [style.color]="color()"
      [class]="iconClass()">
      <path
        d="M7.5 9.16675V14.1667L9.16667 12.5001"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <path
        d="M7.50016 14.1667L5.8335 12.5"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <path
        d="M18.3332 8.33342V12.5001C18.3332 16.6667 16.6665 18.3334 12.4998 18.3334H7.49984C3.33317 18.3334 1.6665 16.6667 1.6665 12.5001V7.50008C1.6665 3.33341 3.33317 1.66675 7.49984 1.66675H11.6665"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <path
        d="M18.3332 8.33341H14.9998C12.4998 8.33341 11.6665 7.50008 11.6665 5.00008V1.66675L18.3332 8.33341Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round" />
    </svg>
  `,
})
export class DownloadFileIconComponent extends BaseIconComponent {}
